import { Card } from "react-bootstrap";

const Footer = () => {
  return (
    <Card.Footer>
      <h6 className="text-center">Hock Seng Lee Berhad &copy; 2024</h6>
    </Card.Footer>
  );
};
export default Footer;
